/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_CopyInputs */

const en_btn_copy = /** @type {(inputs: Btn_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const ko_btn_copy = /** @type {(inputs: Btn_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`복사`)
};

const ja_btn_copy = /** @type {(inputs: Btn_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピー`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Btn_CopyInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const btn_copy = /** @type {((inputs?: Btn_CopyInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_CopyInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_copy(inputs)
	if (locale === "ko") return ko_btn_copy(inputs)
	return ja_btn_copy(inputs)
});